import script from "./OrderFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderFormModal.vue?vue&type=script&setup=true&lang=js"

import "./OrderFormModal.vue?vue&type=style&index=0&id=bfc5ec36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfc5ec36"]])

export default __exports__